import { Dropdown, Menu } from "antd";

export type AudioWaveformLevel = number;

export type AudioWaveformProps = {
  playbackRate: number;
  onPlaybackRateChange?: (rate: number) => void;
  className?: string;
};

export const PlaybackRateSelect: React.FC<AudioWaveformProps> = ({
  playbackRate = 1,
  className,
  onPlaybackRateChange,
}) => {
  return (
    <Dropdown
      trigger={["click"]}
      overlay={
        <Menu selectedKeys={[playbackRate?.toString() ?? "1"]}>
          {[0.5, 1, 1.5, 2].map((rate) => (
            <Menu.Item key={rate} onClick={() => onPlaybackRateChange?.(rate)}>
              {rate.toPrecision(2)}x
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <span className={className}>{playbackRate.toPrecision(2)}x</span>
    </Dropdown>
  );
};
